import { LOCALES } from "@/components/enrichment/config";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export interface DisplayNamesEditorProps {
  value: Record<string, string>;
  onChange: (next: Record<string, string>) => void;
}

/** One input per app language; an empty one means "use the area's own name". */
export const DisplayNamesEditor = ({
  value,
  onChange,
}: DisplayNamesEditorProps) => (
  <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
    {LOCALES.map(({ code, label }) => (
      <div key={code} className="flex flex-col gap-1">
        <Label htmlFor={`display-name-${code}`}>{label}</Label>
        <Input
          id={`display-name-${code}`}
          value={value[code] ?? ""}
          onChange={(e) => onChange({ ...value, [code]: e.target.value })}
        />
      </div>
    ))}
  </div>
);
